export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Dashboard",
    },
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/documents",
    name: "documents",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Active Projects",
    },
    component: () => import("@/views/documents/Index.vue"),
  },
  {
    path: "/proposals",
    name: "proposals",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Proposals",
    },
    component: () => import("@/views/proposals/Index.vue"),
  },
  {
    path: "/documents/:folder/:id",
    name: "documents-folder",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Folder",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/Folder.vue"),
  },
  {
    path: "/documents/:folder/:folderId/:subFolder/:id",
    name: "documents-subfolder",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "SubFolder",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/Folder.vue"),
  },
  {
    path: "/document/details/:id",
    name: "document-details",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Send Document",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/DocumentDetails.vue"),
  },
  {
    path: "/documents/recieved",
    name: "recieved-documents",
    meta: {
      requiresAuth: true,
      roles: ["client", "service_provider"],
      title: "Documents",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/RecievedDocument.vue"),
  },
  {
    path: "/documents/shared/:key?",
    name: "shared-documents",
    meta: {
      requiresAuth: false,
      layout: "full",
      title: "Documents",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/SharedDocument.vue"),
  },
  {
    path: "/documents/sent",
    name: "send-documents",
    meta: {
      requiresAuth: true,
      roles: ["service_provider"],
      title: "Sent Document",
      navActiveLink: "documents",
    },
    component: () => import("@/views/documents/SentDocument.vue"),
  },
  {
    path: "/invoices",
    name: "invoices",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Invoices",
    },
    component: () => import("@/views/invoices/Index.vue"),
  },
  {
    path: "/invoice/details/:invoice/:id",
    name: "invoice-details",
    component: () => import("@/views/invoices/InvoiceDetails.vue"),
    meta: {
      requiresAuth: true,
      roles: ["client", "service_provider"],
      title: "Invoice Details",
      navActiveLink: "invoices",
    },
  },
  {
    path: "/invoice/pay/:invoice",
    name: "pay-invoice",
    component: () => import("@/views/invoices/PayInvoice.vue"),
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Pay Invoice",
      navActiveLink: "invoices",
    },
  },
  {
    path: "/payments",
    name: "payments",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Payments",
    },
    component: () => import("@/views/Payments.vue"),
  },
  // {
  //   path: '/subscription',
  //   name: 'subscription',
  //   meta:{requiresAuth:true, roles:['client','vendor','service_provider','broker'], title: 'Subscription'},
  //   component: () => import('@/views/subscriptions/Index.vue'),
  // },
  {
    path: "/subscription/upgrade-plan/:plan",
    name: "subscription-upgrade-plan",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Upgrade Plan",
      navActiveLink: "settings",
    },
    component: () => import("@/views/subscriptions/UpgradePlan.vue"),
  },
  {
    path: "/archived",
    name: "archive",
    meta: {
      requiresAuth: true,
      roles: ["vendor", "service_provider", "broker"],
      title: "Archived",
    },
    component: () => import("@/views/Backup.vue"),
  },
  {
    path: "/archived/:folder/:id",
    name: "archived-project-folder",
    meta: {
      requiresAuth: true,
      roles: ["vendor", "service_provider", "broker"],
      title: "Archived Project",
      navActiveLink: "archive",
      archivedReadOnly: true,
    },
    component: () => import("@/views/documents/Folder.vue"),
  },
  {
    path: "/archived-file/:id",
    name: "archived-document",
    meta: {
      requiresAuth: true,
      roles: ["vendor", "service_provider", "broker"],
      title: "Document",
      navActiveLink: "archive",
      archivedReadOnly: true,
    },
    component: () => import("@/views/documents/SentDocument.vue"),
  },
  {
    path: "/support-tickets",
    name: "support-tickets",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "My Support Tickets",
      navActiveLink: "settings",
    },
    component: () => import("@/views/support/MySupportTickets.vue"),
  },
  {
    path: "/support-tickets/:id",
    name: "support-ticket-details",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Support Ticket",
      navActiveLink: "settings",
    },
    component: () => import("@/views/support/SupportTicketDetail.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    meta: {
      requiresAuth: true,
      roles: ["client", "vendor", "service_provider", "broker"],
      title: "Settings",
    },
    component: () => import("@/views/Settings.vue"),
  },
];
